import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'ReferralBar.title',
    defaultMessage:
      'Win credits (up to {amount}) by acquiring cards via Auctions or Instant Buy',
  },
  claimSoon: {
    id: 'ReferralBar.claimSoon',
    defaultMessage: 'Your Reward is on its way! It can take 1-3 days.',
  },
  invitedByAnAffiliate: {
    id: 'ReferralBar.affiliate',
    defaultMessage: 'Invited by an affiliate',
  },
});
